import {
  DocumentData,
  DocumentReference,
  serverTimestamp,
  setDoc,
  WithFieldValue,
} from 'firebase/firestore';

export const setDocWithTimestamp = <Data extends DocumentData>(
  ref: DocumentReference,
  data: WithFieldValue<Data>,
) => setDoc(ref, { ...data, updatedAt: serverTimestamp() });
